import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchBackgroundImage = async (fileName) => {
    return apiWrapper({
      fetch,
      url: `assessment/builder/fetchBackgroundImage?fileName=${fileName}`,
      options: {
        method: 'GET'
      }
    });
  }

  const uploadBackgroundImage = async (files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    return apiWrapper({
      fetch,
      url: `assessment/builder/uploadBackgroundImage`,
      options: {
        method: 'POST',
        body: formData
      }
    });
  }

  return {
    fetchBackgroundImage,
    uploadBackgroundImage
  }
}